<ng-container *ngIf="cartItem; else loadingTemplate">
  <ng-container *ngIf="cartItem.count; else zeroCountTemplate">
    <mp-quantity-input [min]="min ?? 0" [max]="cartItem.inventory" [formControl]="quantityControl"></mp-quantity-input>
  </ng-container>
  <ng-template #zeroCountTemplate>
    <button mat-raised-button color="primary" (click)="addItem(cartItem)">Lisa ostukorvi</button>
  </ng-template>
</ng-container>
<ng-template #loadingTemplate>{{ cartItem }}</ng-template>
